// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Service-module--arrow--16Dw2","root":"Service-module--root--1b-YC","title":"Service-module--title--2TZGX","image":"Service-module--image--3bmuy"};